import React, { Fragment }  from 'react';
import { Icon,  Header,  Form, Label } from 'semantic-ui-react';
import yup from 'yup';
import Field from '../Field';
import VerificationFormField from '../VerificationFormField'
import withVericationForm from './withVericationForm'
import FlightDate from '../FlightDate'

const ERROR_REQUIRED = 'This field is required'

class FlightInvoice extends React.PureComponent {

  isFlightInvoiceInputDisabled = () => {
    const {values} = this.props
    const valuesToValidate = [
      values.validFlightNumber,
      values.validDepartureDatetime,
      values.validArrivalDatetime,
      values.validTrip,
      values.validOperatingAirline
    ]
    return this.props.isInputDisabled(valuesToValidate)
  }

  _onChange = (e, {name, value} ) => this.props.onChange(this.props.documentId, name, value)

  render = () => {
    const {
      onBlur,
      values,
      errors,
      touched
    } = this.props;
    const isFlightInvoiceInputDisabled = this.isFlightInvoiceInputDisabled()
    return (
      <Fragment>
        <Header>
          Flight invoice
        </Header>
        <Form>
          <Field
            error={errors.validFlightNumber}
            touched={touched.validFlightNumber}
          >
            <VerificationFormField
              name="validFlightNumber"
              value={values.validFlightNumber}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validFlightNumber')}>

              <p>Flight number is </p>
              <Label>{this.flightNumber()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validOperatingAirline}
            touched={touched.validOperatingAirline}
          >
            <VerificationFormField
              name="validOperatingAirline"
              value={values.validOperatingAirline}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validOperatingAirline')}>

              <p>Airline is </p>
              <Label>{this.airline()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validTrip}
            touched={touched.validTrip}
          >
            <VerificationFormField
              name="validTrip"
              value={values.validTrip}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validTrip')}>

              <p>Trip is </p>
              <Label>{this.originIATA()}</Label>
              <Icon name="arrow right" />
              <Label>{this.destinationIATA()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validDepartureDatetime}
            touched={touched.validDepartureDatetime}
          >
            <VerificationFormField
              name="validDepartureDatetime"
              value={values.validDepartureDatetime}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validDepartureDatetime')}>

              <p>Departure date is </p>
              <Label>{this.departureDate()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validArrivalDatetime}
            touched={touched.validArrivalDatetime}
          >
            <VerificationFormField
              name="validArrivalDatetime"
              value={values.validArrivalDatetime}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validArrivalDatetime')}>

              <p>Arrival date is </p>
              <Label>{this.arrivalDate()}</Label>

            </VerificationFormField>
          </Field>
          <Form.Input
            label="PNR"
            placeholder="PNR"
            name="pnr"
            value={values.pnr}
            onChange={this._onChange}
            disabled={isFlightInvoiceInputDisabled}
            onBlur={onBlur.bind(this, 'PNR')}
          />
          <Field
            error={errors.ticketNumber}
            touched={touched.ticketNumber}
          >
            <Form.Input
              label="Ticket number"
              placeholder="ticket number"
              name="ticketNumber"
              value={values.ticketNumber}
              onChange={this._onChange}
              disabled={isFlightInvoiceInputDisabled}
              onBlur={onBlur.bind(this, 'ticketNumber')}
            />
          </Field>
        </Form>
      </Fragment>
    )
  }
  passengerName(){
    const passengerTicket = this.props.passengerTicket
    if(!passengerTicket){
      return ''
    }
    return [
      passengerTicket.passengerFirstName,
      passengerTicket.passengerLastName].join(' ')
  }
  flightNumber(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airline.iata + flight.number
  }
  originIATA(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airportOrigin.iata
  }
  destinationIATA(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airportDestination.iata
  }
  airline(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airline.name
  }
  departureDate(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return <FlightDate date={flight.localDepartureDate} />
  }
  arrivalDate(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return <FlightDate date={flight.localArrivalDate} />
  }
}

const formikConfig = {
  mapPropsToValues: props => {
    return {...props.formValues}
  },
  validationSchema: () => {
    return yup.object().shape({
      validFlightNumber: yup.boolean().required(ERROR_REQUIRED),
      validOperatingAirline: yup.boolean().required(ERROR_REQUIRED),
      validDepartureDatetime: yup.boolean().required(ERROR_REQUIRED),
      validArrivalDatetime: yup.boolean().required(ERROR_REQUIRED),
      validTrip: yup.boolean().required(ERROR_REQUIRED)
    });
  }
};

export default withVericationForm(formikConfig, [
  'validFlightNumber',
  'validOperatingAirline',
  'validTrip',
  'validDepartureDatetime',
  'validArrivalDatetime',
  'ticketNumber'
])(FlightInvoice);



// WEBPACK FOOTER //
// ./src/component/verification_forms/FlightInvoiceForm.js